import {
  ModalConfig,
  ModalParams,
  ModalStore,
  createStore,
  modalStoreGenerator,
} from '@packages/stores';

import { FullScreenModalProps, ModalComponentName } from '@components';
import { ModalProps } from '@elements/modal';

type ModalBodyType = ModalComponentName;
export type _ModalParams = ModalParams<ModalProps | FullScreenModalProps>;

export type _ModalConfig = ModalConfig<ModalProps | FullScreenModalProps>;

export type _ModalStore = ModalStore<ModalProps | FullScreenModalProps, ModalBodyType>;

export const useModalStore = createStore(
  modalStoreGenerator<ModalProps | FullScreenModalProps, ModalBodyType>({
    modals: [],
    uniqueModals: ['RegionGridModal'],
  }),
  {
    name: 'useModalStore',
    shouldPersist: false,
  },
);
